import { render } from "./NavBarLeft.vue?vue&type=template&id=b1343bb8"
import script from "./NavBarLeft.vue?vue&type=script&lang=js"
export * from "./NavBarLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__